import i18n from 'i18next'

import { getStringDuration } from '../../utils/getStringExecutionDuration'

export const getEstimatedTestDuration = (numOfImages: number): string => {
  let seconds = 0.4 * numOfImages + 180
  seconds += 6 * 60 // add 6 min for provisioning

  return seconds > 0
    ? i18n.t('Estimated minimum test duration: {{ duration }}.', {
        duration: getStringDuration(seconds),
      })
    : i18n.t('Impossible to estimate the test duration.')
}
